import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./SearchFloatingInside.css";

const API_BASE_URL = "/api";
// OR try without port if your backend serves both API and frontend:
// const API_BASE_URL = window.location.origin; // This will use the same origin as frontend

// ✅ FIX: Enhanced axios instance with CORS handling
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
  // Add withCredentials if needed for cookies/auth
  // withCredentials: true,
});

// ✅ FIX: Add request interceptor for debugging
api.interceptors.request.use(
  (config) => {
    console.log(
      `🚀 Making ${config.method?.toUpperCase()} request to:`,
      config.url
    );
    console.log("Full config:", config);
    return config;
  },
  (error) => {
    console.error("❌ Request error:", error);
    return Promise.reject(error);
  }
);

// ✅ FIX: Add response interceptor
api.interceptors.response.use(
  (response) => {
    console.log(`✅ Response from ${response.config.url}:`, response.status);
    return response;
  },
  (error) => {
    console.error("❌ Response error:", {
      message: error.message,
      code: error.code,
      status: error.response?.status,
      url: error.config?.url,
    });
    return Promise.reject(error);
  }
);

export default function SearchFloating({ applyFilters, initial }) {
  const navigate = useNavigate();
  const [q, setQ] = useState(initial.q || "");
  const [city, setCity] = useState(initial.city || "");
  const [type, setType] = useState(initial.type || "");
  const [minPrice, setMinPrice] = useState(initial.minPrice || "");
  const [maxPrice, setMaxPrice] = useState(initial.maxPrice || "");

  const [properties, setProperties] = useState([]);
  const [transactionType, setTransactionType] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("Pune");
  const [selectedPropertyType, setSelectedPropertyType] = useState("");
  const [minSqft, setMinSqft] = useState("");
  const [maxSqft, setMaxSqft] = useState("");
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        // ✅ CHANGED: Use relative URL instead of localhost
        const response = await api.get("/test");
        // OLD: "http://localhost:3000/test"
        setProperties(response.data);
      } catch (error) {
        console.error("Error fetching properties:", error);
      }
    };
    fetchProperties();
  }, []);

  useEffect(() => {
    if (selectedPropertyType) {
      // ✅ CHANGED: Use relative URL instead of localhost
      api
        .get(`/areas?type=${encodeURIComponent(selectedPropertyType)}`)
        // OLD: `http://localhost:3000/areas?type=${encodeURIComponent(selectedPropertyType)}`
        .then((res) => {
          if (res.data && res.data.success) {
            setAreas(res.data.data);
          } else {
            setAreas([]);
          }
          setSelectedArea("");
        })
        .catch((err) => {
          console.error("Error fetching areas:", err);
          setAreas([]);
        });
    } else {
      setAreas([]);
    }
  }, [selectedPropertyType]);

  const propertyTypes = [...new Set(properties.map((p) => p.type))];

  const handleSearch = () => {
    // Create search params object with all selected criteria
    const searchParams = {
      transactionType: transactionType,
      location: selectedLocation,
      propertyType: selectedPropertyType,
      minSqft,
      maxSqft,
    };
    navigate(`/properties?${new URLSearchParams(searchParams).toString()}`);
  };

  return (
    <div className="search-floating-holder">
      <form className="search-floating">
        {/* Field 1 */}

        <div className="search-field">
          <label>Property Type</label>

          <div className="field-input select-like">
            <select
              value={selectedPropertyType}
              onChange={(e) => setSelectedPropertyType(e.target.value)}
              className="search-select"
              required
            >
              <option value="">Property Type</option>
              {propertyTypes.map((type, index) => (
                <option key={index} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Field 2 */}

        <div className="search-field">
          <label>Location</label>

          <div className="field-input">
            <select
              value={selectedLocation}
              onChange={(e) => setSelectedLocation(e.target.value)}
              className="search-select"
            >
              <option value="">Select Location</option>
              {areas.map((a, index) => (
                <option key={index} value={a.area}>
                  {a.area}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="search-field">
          <label>Transaction Type</label>

          <div className="field-input">
            <select
              value={transactionType}
              onChange={(e) => {
                setTransactionType(e.target.value);
              }}
              className="search-select"
              required
            >
              <option value="">Select Transaction Type</option>
              <option value="Rental">Rental</option>
              <option value="Purchase">Purchase</option>
              <option value="ReadyToUse">Ready To Use</option>
              <option value="Land">Land</option>
            </select>
          </div>
        </div>

        {/* Min & Max Sqft Inputs */}
        <div className="search-field small-input">
          <label>Min Area In Sqft</label>
          <input
            type="number"
            className="search-select"
            placeholder="Min"
            value={minSqft}
            onChange={(e) => setMinSqft(e.target.value)}
          />
        </div>

        <div className="search-field small-input">
          <label>Max Area In Sqft</label>
          <input
            type="number"
            className="search-select"
            placeholder="Max"
            value={maxSqft}
            onChange={(e) => setMaxSqft(e.target.value)}
          />
        </div>

        <div className="sf-col sf-action">
          <button
            className="search-button newbut"
            onClick={(e) => {
              e.preventDefault(); // ⛔ stop form reload
              handleSearch(); // ✅ redirect with params
            }}
          >
            SEARCH
          </button>
        </div>
      </form>
    </div>
  );
}
